import { useEffect } from 'react';
import { DashboardFilter } from 'generated/maya.types';
import useCountCepQuery from 'modules/maya/graphql/queries/countCep';

const useCountCepWidget = (filters?: DashboardFilter) => {
  const { countCepQuery, cepData, loading, error } = useCountCepQuery();

  useEffect(() => {
    if (filters) {
      countCepQuery({ variables: { filters } });
    }
  }, [filters, countCepQuery]);

  return {
    value: cepData,
    loading,
    error,
  };
};

export default useCountCepWidget;
